import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, PawIcon } from './Icons';
const testimonials = [{
  quote: "My Mastiff's energy exploded in just 7 days.",
  name: 'Mike R.',
  location: 'Ohio',
  breed: 'English Mastiff'
}, {
  quote: "The best investment for my Cane Corso's joints.",
  name: 'John D.',
  location: 'Texas',
  breed: 'Cane Corso'
}, {
  quote: 'Every large breed owner needs this blueprint.',
  name: 'Sarah L.',
  location: 'Florida',
  breed: 'Great Dane'
}];
export function TestimonialsSection() {
  return <section className="relative w-full py-20 sm:py-28 overflow-hidden bg-bg-primary" aria-label="Customer testimonials" data-id="element-356">
      <div className="max-w-5xl mx-auto px-5 sm:px-8" data-id="element-357">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-358">
          <p className="font-sans text-xs sm:text-sm tracking-[0.2em] uppercase text-gold/70 mb-3" data-id="element-359">
            Real Results
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream" data-id="element-360">
            What Giant Breed Owners Are Saying
          </h2>
        </motion.div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-361">
          {testimonials.map((t, index) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative bg-bg-card/60 border border-white/5 rounded-2xl p-6 sm:p-8 flex flex-col" data-id="element-362">
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-5" data-id="element-363">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold" data-id="element-364" />)}
              </div>

              {/* Quote */}
              <blockquote className="font-serif text-lg sm:text-xl font-semibold text-cream leading-snug mb-6 flex-1" data-id="element-365">
                "{t.quote}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-white/5" data-id="element-366">
                <div className="w-10 h-10 rounded-full bg-green-deep/30 border border-green-accent/20 flex items-center justify-center flex-shrink-0" data-id="element-367">
                  <PawIcon className="w-5 h-5 text-green-accent" data-id="element-368" />
                </div>
                <div data-id="element-369">
                  <p className="font-sans text-sm font-semibold text-cream" data-id="element-370">
                    {t.name}
                  </p>
                  <p className="font-sans text-xs text-cream-muted" data-id="element-371">
                    {t.location} — {t.breed} Owner
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}